import { ITelemetryData } from "../../types/telemetry";

/**
 * Sends telemetry data to the given tracking endpoint.
 * Uses `navigator.sendBeacon` when available, falling back to a `fetch` POST request.
 */
export function sendTelemetryData(data: ITelemetryData, trackingEndpoint: string): void {
    const jsonData = JSON.stringify(data);

    if (
        window &&
        window.navigator &&
        typeof window.navigator.sendBeacon === "function" &&
        typeof window.Blob === "function"
    ) {
        const blobData = new window.Blob([jsonData], {
            type: "application/json"
        });

        try {
            if (window.navigator.sendBeacon(trackingEndpoint, blobData)) return;
        } catch (_e) {
            // fallback below
        }
    }

    setTimeout(() => {
        fetch(trackingEndpoint, {
            body: jsonData,
            headers: {
                "Content-Type": "application/json"
            },
            method: "POST"
        });
    }, 0);
}
